/**
 * Ad Blocker Detection Script
 * Detects if an ad blocker (like uBlock Origin) is active and displays a warning message
 */

(function() {
    'use strict';

    const AdBlockDetector = {
        // Configuration
        config: {
            warningMessage: 'Our website does not work with pop-up blockers like uBlock Origin. Please disable your pop-up blocker while using our site.',
            checkDelay: 100,
            baitElementId: 'ad-banner-detector',
            warningContainerId: 'adblock-warning-container'
        },

        /**
         * Initialize the ad blocker detection
         */
        init: function() {
            // Wait for DOM to be ready
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => this.detect());
            } else {
                this.detect();
            }
        },

        /**
         * Create a bait element that ad blockers typically block
         */
        createBaitElement: function() {
            const bait = document.createElement('div');
            bait.id = this.config.baitElementId;
            bait.className = 'pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links ad-text adSense adBlock adContent adBanner';
            bait.style.cssText = 'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;';
            bait.innerHTML = '&nbsp;';

            return bait;
        },

        /**
         * Check if the bait element is blocked
         */
        isBaitBlocked: function(bait) {
            // Multiple detection methods for better accuracy
            if (window.getComputedStyle !== undefined) {
                const computedStyle = window.getComputedStyle(bait);

                // Check if element is hidden or has zero dimensions
                if (computedStyle.getPropertyValue('display') === 'none' ||
                    computedStyle.getPropertyValue('visibility') === 'hidden' ||
                    bait.offsetParent === null ||
                    bait.offsetHeight === 0 ||
                    bait.offsetLeft === 0 ||
                    bait.offsetTop === 0 ||
                    bait.offsetWidth === 0 ||
                    bait.clientHeight === 0 ||
                    bait.clientWidth === 0) {
                    return true;
                }
            }

            // Additional check for element removal
            if (bait.parentNode === null) {
                return true;
            }

            return false;
        },

        /**
         * Create and display the warning message
         */
        showWarning: function() {
            // Check if warning already exists
            if (document.getElementById(this.config.warningContainerId)) {
                return;
            }

            const warningContainer = document.createElement('div');
            warningContainer.id = this.config.warningContainerId;
            warningContainer.innerHTML = `
                <div style="
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
                    color: white;
                    padding: 16px 20px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    z-index: 999999;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
                    animation: slideDown 0.4s ease-out;
                ">
                    <div style="
                        max-width: 1200px;
                        margin: 0 auto;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        flex-wrap: wrap;
                        gap: 12px;
                    ">
                        <div style="display: flex; align-items: center; gap: 12px; flex: 1; min-width: 250px;">
                            <svg style="width: 24px; height: 24px; flex-shrink: 0;" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
                            </svg>
                            <div>
                                <div style="font-weight: 600; font-size: 15px; margin-bottom: 2px;">
                                    Ad Blocker Detected
                                </div>
                                <div style="font-size: 14px; opacity: 0.95; line-height: 1.4;">
                                    ${this.config.warningMessage}
                                </div>
                            </div>
                        </div>
                        <button
                            id="adblock-dismiss-btn"
                            style="
                                background: rgba(255, 255, 255, 0.2);
                                border: 1px solid rgba(255, 255, 255, 0.3);
                                color: white;
                                padding: 8px 16px;
                                border-radius: 6px;
                                cursor: pointer;
                                font-size: 14px;
                                font-weight: 500;
                                transition: all 0.2s;
                                white-space: nowrap;
                            "
                            onmouseover="this.style.background='rgba(255, 255, 255, 0.3)'"
                            onmouseout="this.style.background='rgba(255, 255, 255, 0.2)'"
                        >
                            Dismiss
                        </button>
                    </div>
                </div>
                <style>
                    @keyframes slideDown {
                        from {
                            transform: translateY(-100%);
                            opacity: 0;
                        }
                        to {
                            transform: translateY(0);
                            opacity: 1;
                        }
                    }

                    @media (max-width: 640px) {
                        #${this.config.warningContainerId} > div {
                            padding: 14px 16px !important;
                        }
                        #${this.config.warningContainerId} button {
                            width: 100%;
                            margin-top: 8px;
                        }
                    }
                </style>
            `;

            document.body.insertBefore(warningContainer, document.body.firstChild);

            // Add padding to body to prevent content from being hidden
            document.body.style.paddingTop = warningContainer.offsetHeight + 'px';

            // Setup dismiss button with ad blocker check
            this.setupDismissButton();

            // Start continuous monitoring
            this.startMonitoring();

            // Log detection for debugging
            console.warn('Ad blocker detected. Some features may not work correctly.');
        },

        /**
         * Setup dismiss button to only work when ad blocker is disabled
         */
        setupDismissButton: function() {
            const dismissBtn = document.getElementById('adblock-dismiss-btn');
            if (!dismissBtn) return;

            dismissBtn.addEventListener('click', () => {
                // Check if ad blocker is still active
                const bait = this.createBaitElement();
                document.body.appendChild(bait);

                setTimeout(() => {
                    const isBlocked = this.isBaitBlocked(bait);

                    // Clean up bait
                    if (bait.parentNode) {
                        bait.parentNode.removeChild(bait);
                    }

                    if (isBlocked) {
                        // Ad blocker still active - show feedback
                        this.showDismissError(dismissBtn);
                    } else {
                        // Ad blocker disabled - allow dismiss
                        this.removeWarning();
                    }
                }, this.config.checkDelay);
            });
        },

        /**
         * Show error feedback when trying to dismiss with ad blocker active
         */
        showDismissError: function(button) {
            const originalText = button.textContent;
            button.textContent = 'Please disable ad blocker first';
            button.style.background = 'rgba(255, 255, 255, 0.4)';
            button.style.animation = 'shake 0.5s';

            // Add shake animation
            const style = document.createElement('style');
            style.textContent = `
                @keyframes shake {
                    0%, 100% { transform: translateX(0); }
                    25% { transform: translateX(-10px); }
                    75% { transform: translateX(10px); }
                }
            `;
            document.head.appendChild(style);

            setTimeout(() => {
                button.textContent = originalText;
                button.style.background = 'rgba(255, 255, 255, 0.2)';
                button.style.animation = '';
            }, 2000);
        },

        /**
         * Remove warning and restore page
         */
        removeWarning: function() {
            const container = document.getElementById(this.config.warningContainerId);
            if (container) {
                container.remove();
                document.body.style.paddingTop = '';

                // Stop monitoring
                if (this.monitoringInterval) {
                    clearInterval(this.monitoringInterval);
                }
            }
        },

        /**
         * Continuously monitor for ad blocker status
         */
        startMonitoring: function() {
            // Check every 2 seconds if ad blocker is disabled
            this.monitoringInterval = setInterval(() => {
                const bait = this.createBaitElement();
                document.body.appendChild(bait);

                setTimeout(() => {
                    const isBlocked = this.isBaitBlocked(bait);

                    // Clean up bait
                    if (bait.parentNode) {
                        bait.parentNode.removeChild(bait);
                    }

                    // If ad blocker is disabled, auto-dismiss
                    if (!isBlocked) {
                        this.removeWarning();
                        console.log('Ad blocker disabled - warning removed');
                    }
                }, this.config.checkDelay);
            }, 2000);
        },

        /**
         * Main detection logic
         */
        detect: function() {
            const bait = this.createBaitElement();
            document.body.appendChild(bait);

            // Wait a bit for ad blockers to process the element
            setTimeout(() => {
                if (this.isBaitBlocked(bait)) {
                    this.showWarning();
                }

                // Clean up bait element
                if (bait.parentNode) {
                    bait.parentNode.removeChild(bait);
                }
            }, this.config.checkDelay);
        },

        /**
         * Alternative detection method using fetch
         */
        detectViaFetch: function() {
            // Try to fetch a common ad-related URL that would be blocked
            fetch('https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', {
                method: 'HEAD',
                mode: 'no-cors',
                cache: 'no-store'
            }).catch(() => {
                this.showWarning();
            });
        }
    };

    // Initialize the detector
    AdBlockDetector.init();

    // Expose to window for manual triggering if needed
    window.AdBlockDetector = AdBlockDetector;
})();
